export const initialCourseValues = {
  Engineering: "15 ",
  Medical: "25 ",
  Law: "10 ",
  Design: "15 ",
  MBA: "20 ",
  Others: "10 ",
};
